// feat_347 — constantes y helper del modelo de acciones por tipo de media
// (feat_225). Movidos VERBATIM desde Settings/index.js: los consumen el shell
// (hidrata el estado desde GET /settings y desde el socket) y el tab que dibuja
// los 6 selectores. Antes vivían a nivel de módulo en index.js; al partir la
// pantalla en tabs necesitan un módulo propio para no duplicarse.
// feat_352 — ese consumidor era `TabIA.js`, que se borró: el bloque "Respuesta
// automática a media" vive ahora en `tabs/TabAutomatizaciones.js`.

export const MEDIA_TYPES = ["audio", "video", "image", "document", "sticker", "reaction"];
export const MEDIA_ACTIONS = ["ai", "ignore", "reply"];
export const DEFAULT_MEDIA_ACTIONS = {
	audio: "reply",
	video: "reply",
	image: "ai",
	document: "ai",
	sticker: "ignore",
	reaction: "ai"
};

// Deriva el mapa de acciones desde el setting nuevo (autoReplyMediaActions) con
// fallback retrocompat al viejo (autoReplyMediaTypes array → esos tipos = "reply").
export const deriveMediaActions = (rawActions, rawTypes) => {
	try {
		if (rawActions) {
			const parsed = JSON.parse(rawActions);
			if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
				const out = { ...DEFAULT_MEDIA_ACTIONS };
				MEDIA_TYPES.forEach(t => {
					if (MEDIA_ACTIONS.includes(parsed[t])) out[t] = parsed[t];
				});
				return out;
			}
		}
	} catch (_) { /* fall through */ }
	try {
		if (rawTypes) {
			const parsed = JSON.parse(rawTypes);
			if (Array.isArray(parsed)) {
				const out = {};
				MEDIA_TYPES.forEach(t => { out[t] = parsed.includes(t) ? "reply" : "ai"; });
				return out;
			}
		}
	} catch (_) { /* fall through */ }
	return { ...DEFAULT_MEDIA_ACTIONS };
};
